<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row ">
                <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 ">
                    <div class="info-box bg-c-yellow card">
                        <div class="info-box-content">
                            <h6><span class="info-box-text">Commission</span></h6>
                            <h2><span class="info-box-number" ><small>$</small>{{ Commission.total_amount }}</span></h2>
                            <p class="m-b-0">
                                
                                <i class="feather icon-arrow-up m-l-10"></i>
                                
                            </p>
                            <i class="card-icon feather icon-filter"></i>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->
                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <div class="info-box bg-c-blue card">
                        <div class="info-box-content">
                            <h6><span class="info-box-text">Orders Received</span></h6>
                            <h2><span class="info-box-number">{{ OrdersReceived.total_number }}</span> </h2>
                            <p class="m-b-0">
                                
                                <!-- <i class="feather icon-arrow-up m-l-10"></i> -->
                            </p>
                            <i class="card-icon feather icon-users"></i>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->

                <!-- fix for small devices only -->
                <!-- <div class="clearfix hidden-md-up"></div> -->
                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <div class="info-box bg-c-green card">
                        <div class="info-box-content">
                            <h6><span class="info-box-text">Total Sales</span></h6>
                            <h2><span class="info-box-number">{{ TotalSales.total_reached }}</span> </h2>
                            <p class="m-b-0">
                                From  possible
                                <!-- <i class="feather icon-arrow-up m-l-10"></i> -->
                            </p>
                            <i class="card-icon feather icon-radio"></i>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                    <!-- /.info-box -->
                </div>
                <!-- /.col -->
            <!-- /.col -->
            </div>
            <!-- /.row -->

            <div class="row">
                
                <!-- /.card -->
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-2">
                                    <h5 class="card-title">Paid Invoices</h5>
                                </div>
                                <div class="col-md-3">
                                    <h5 class="card-title text-left">KPI Reached</h5>
                                </div>
                                <div class="col-md-7 text-right p-r-6">
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                        <button type="button" class="btn btn-tool" data-card-widget="remove">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table table-striped table-bordered" id="simulation-tables">
                                    <thead>
                                        <tr>
                                            <th v-for="(item, index) in TableHeaders">{{ item }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in tableData">{{ item }}</tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.card -->
                
            </div>
            <!-- /.col -->
            
            </div>
            <!-- /.row -->

            
        </div><!--/. container-fluid -->
    </section>
</template>
    
<script>
    export default {
        data () {
            return {
               tableData: {},
               TableHeaders: {},
               Commission: {},
               OrdersReceived: {},
               TotalSales: {},
            }
        },
        mounted() {
            console.log('Simulation mounted.');
            console.log('load');
            
        },
        updated: function () {

          this.$nextTick(function () {
                $('#simulation-table').DataTable({
                    ordering: true,
                });
          });

        },
        methods: {
            loadTableData() {
                axios.get("/api/v1/simulation").then(({ data }) => {
                    this.TableHeaders = data.data.TableHeaders;
                    this.tableData = data.data.tableData
                });
            }
        },
        created() {
            this.$Progress.start();
            this.loadTableData();
            this.$Progress.finish();
        }
    }
</script>
